import { assertNever } from '@kofno/piper';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { Link } from '../../../../../../../../../Resource/Types';
import FlashMessage from '../../../../../../../../FlashMessage';
import { LearningCollectionResource } from '../../../../../../../Types';
import { filterGroups, filterParticipants } from '../../../../../../Functions';
import ParticipantDynamicTypeaheadSelect from '../../../../../../ParticipantDynamicTypeaheadSelect';
import { FilterOption } from '../../../../../../ParticipantDynamicTypeaheadSelect/UseParticipantDynamicTypeaheadSelect/Types';
import InviteParticipantStore from '../../../../Store';
import { SelectParticipantsState } from '../../../../Types';
import Collection from './Collection';
import ParticipantsList from './ParticipantsList';
import ToBeAdded from './ToBeAdded';

export interface Props {
  link: Link;
  store: InviteParticipantStore;
  learningCollectionResource: LearningCollectionResource;
  state: SelectParticipantsState;
}

const onChange = (store: InviteParticipantStore) => (option: FilterOption) => {
  option.payload.type.do((type) => {
    switch (type) {
      case 'participant':
        store.addParticipant(option);
        break;
      case 'group':
        store.addGroup(option);
        break;
      default:
        assertNever(type);
    }
  });
};

function Body({ link, store, learningCollectionResource, state }: Props) {
  return (
    <>
      {store.notification.map((alert) => <FlashMessage alert={alert} />).getOrElse(emptyFragment)}
      <Collection name={learningCollectionResource.payload.name} />
      <ParticipantDynamicTypeaheadSelect
        newGroups={filterGroups(state.newGroupsAndParticipants)}
        newParticipants={filterParticipants(state.newGroupsAndParticipants)}
        endpoint={link}
        name="participants"
        label="Select Participants or Groups"
        onChange={onChange(store)}
        initialValue={nothing()}
        labelClassname="py-1.5 text-sm font-semibold text-gray-800 block"
        placeholder="Enter Participant Name, Email or Group Name"
      />
      <ToBeAdded state={state} />
      <ParticipantsList store={store} state={state} />
    </>
  );
}

export default observer(Body);
